import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";
import { FieldError, RequiredMark } from "./FormLayout";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): `BField` en
// BenefitsScreen.tsx y `RField` en RewardsScreen.tsx eran el mismo
// componente palabra por palabra. No se reutiliza `Field` de FormField.tsx
// porque acá conviven `hint` y `required` con la tipografía exacta del
// prototipo (admin.jsx:83-90) — un `<label>` de bloque con `className="label"`
// para el rótulo, distinto del `<label style={fieldStyle}>` con `<span>` de
// `Field`. Extracción sin cambio de comportamiento ni de valores visuales:
// ninguna pantalla que la use cambia un pixel por esto.
export function LabeledField({
  label,
  required,
  hint,
  error,
  children,
}: {
  label: string;
  required?: boolean;
  hint?: string | undefined;
  error?: string | undefined;
  children: ReactNode;
}) {
  return (
    <label style={{ display: "block", marginBottom: 16 }}>
      <div className="label" style={{ marginBottom: 7 }}>
        {label}
        {required ? <RequiredMark /> : null}
      </div>
      {children}
      {hint ? (
        <div
          style={{
            font: `400 11px/1.45 ${tokens.font.ui}`,
            color: tokens.text.disabled,
            marginTop: 6,
          }}
        >
          {hint}
        </div>
      ) : null}
      {error ? <FieldError message={error} /> : null}
    </label>
  );
}
